/*
 * Copyright (C) 2021 Quartet Health, Inc - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */

export const colors = {
  brandPurple: '#5B11E6',
  darkPurple: '#490EB8',
  lightPurple: '#6B29E9',
  lighterPurple: '#AD88F3',
  lightestPurple: '#EFE8FE',
  newLightestPurple: '#F7F3FE',
  neutral01: '#F9F5F3',
  neutral02: '#F7EFEA',
  neutral03: '#F5E9E2',
  neutral04: '#EFE2D9',
  neutral05: '#ECE9F3',
  neutral06: '#F5F3F2',
  neutral07: '#E8DDD6',
  neutral08: ' #F2EFED',
  neutralLight: '#FFFAF0',
  red: '#E32B2B',
  yellow: '#FFCD00',
  green: '#04A676',
  coolGreen: '#7EB798',
  lightGreen: '#F4F8F5',
  grey100: '#17033B',
  grey90: '#17043A',
  grey80: '#433F5D',
  grey50: '#737283',
  grey30: '#B8B8C4',
  grey20: '#D5D7DD',
  grey15: '#E7E5EB',
  grey10: '#E3E6EB',
  grey05: '#F3F4F7',
  grey01: '#F9F9FB',
  lightGrey: '#FBFBFB',
  greyHTMLText: '#737283',
  white: '#FFFFFF',
  black: '#000000'
};
